module.exports = __webpack_public_path__ + "static/img/16052C_5_6_R_20200529_LC.c27caa2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/16052C_5_6_R_20200529_LC.png
// module id = FutU
// module chunks = 0